export function recipeFavoritePrincipalKey(input: {
  userId: string;
  sharedTablet: boolean;
  tenantPersonnelId?: string | null;
}): string | null {
  if (!input.sharedTablet) return `account:${input.userId}`;
  return input.tenantPersonnelId ? `personnel:${input.tenantPersonnelId}` : null;
}

export function applyFavorite(favorites: string[], recipeId: string, favorite: boolean): string[] {
  const next = new Set(favorites);
  if (favorite) next.add(recipeId);
  else next.delete(recipeId);
  return [...next];
}

type PrintableFavoriteRecipe = {
  id: string;
  archived_at?: string | null;
  is_food_cost_only?: boolean;
  variant_of_recipe_id?: string | null;
};

export function selectPrintableFavoriteRecipes<T extends PrintableFavoriteRecipe>(
  recipes: T[],
  favoriteIds: ReadonlySet<string>,
): T[] {
  return recipes.filter(
    (recipe) =>
      favoriteIds.has(recipe.id)
      && !recipe.archived_at
      && !recipe.is_food_cost_only
      && recipe.variant_of_recipe_id == null,
  );
}
